/**
 * Single home for every price written into the frontend.
 *
 * Change a number here and every checkout, page and copy string follows. A price
 * change still needs a build + deploy; moving these into WooCommerce (where the
 * mask and CPAP prices already live) is the change that would remove the deploy.
 *
 * WHAT IS *NOT* HERE, and why:
 *   Renuma+ Phase 1 and Phase 2 are charged as WooCommerce machine price /
 *   QUOTES_CPAP_MACHINE and mask price / QUOTES_MASK (see utils.jsx). The card is
 *   charged from those, never from this file. The two PRICE_PHASE_* values below
 *   are marketing copy only, and must be kept in step by hand when the
 *   WooCommerce prices move.
 */

/** Home sleep test (WatchPAT ONE). Charged from WooCommerce; copy only. */
export const PRICE_SLEEP_STUDY = 199;

/**
 * Telemedicine visit with a sleep doctor.
 *
 * The post-study visit and follow-up check-ins are the same booking flow, so this
 * one number covers both. This IS the charged amount - AppointmentCheckout sends
 * it as `subtotal` and order/post.py bills it verbatim.
 */
export const PRICE_DOCTOR_VISIT = 40;

/** Renuma+ Phase 1, months 1-10. Copy only (machine price / 10). */
export const PRICE_PHASE_1 = 100;

/** Renuma+ Phase 2, month 11 on. Copy only (mask price / 6 = 240/6). */
export const PRICE_PHASE_2 = 40;

/**
 * URL token that puts the telemedicine flow into free mode, retained as an
 * internal testing path: /onboarding/telemedicine/internal_free
 *
 * Deliberately NOT "free" any more. Sleep-study results emails already sitting in
 * patients' inboxes link to /onboarding/telemedicine/free; with this token
 * renamed those links fall through to the normal paid flow instead of handing out
 * free visits. Do not change it back.
 */
export const FREE_FLOW_TOKEN = "internal_free";
